import * as React from "react";

type OwnProps = React.AnchorHTMLAttributes<any> & {
    address: string;
};

export const EmailLink: React.SFC<OwnProps> = (props) => {
    return <a { ...props } href={`mailto:${props.address}`}>{props.address}</a>;
};



// WEBPACK FOOTER //
// ./src/components/generic/EmailLink.tsx